import { FaApple, FaGooglePlay } from "react-icons/fa";

export default function ComingSoonButtons({ className = "" }) {
  const android = typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      {[
        { Icon: FaApple, top: "Coming soon to", store: "App Store", tid: "appstore-coming-soon" },
        { Icon: FaGooglePlay, top: "Coming soon to", store: "Google Play", tid: "googleplay-coming-soon" },
      ].sort((a,b)=>android?(a.store==='Google Play'?-1:1):(a.store==='App Store'?-1:1)).map(({ Icon, top, store, tid }) => (
        <div
          key={store}
          data-testid={tid}
          aria-disabled="true"
          className="relative flex cursor-default items-center gap-3 rounded-full border border-border bg-white px-5 py-3 text-navy shadow-soft"
          title="Coming soon"
        >
          <Icon size={20} />
          <span className="text-left leading-none">
            <span className="block text-[10px] font-medium text-bodygrey">{top}</span>
            <span className="block text-sm font-semibold">{store}</span>
          </span>
          <span className="ml-1 rounded-full bg-orange/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-orange">
            Soon
          </span>
        </div>
      ))}
    </div>
  );
}

